// src/services/api.js
// Service layer untuk komunikasi React -> Google Apps Script -> Google Sheets
// Pengganti firebase.js / Firestore SDK di aplikasi sebelumnya.

const API_URL = 'https://script.google.com/macros/s/AKfycbwzqmv0teXPC0wCV0XWWowSVVtNJU_kTYNgFtqQVWOYU1S-F4NzZKRDbZ3JwRn1bb6c_g/exec';
const API_KEY = 'sklh-2026-kadek'; // harus sama dengan API_KEY di Code.gs

async function callApi(action, payload = {}) {
  const response = await fetch(API_URL, {
    method: 'POST',
    // Sengaja text/plain, BUKAN application/json — supaya browser tidak
    // mengirim CORS preflight (OPTIONS) yang sering gagal di Apps Script.
    headers: { 'Content-Type': 'text/plain' },
    body: JSON.stringify({ action, payload, apiKey: API_KEY }),
  });
  const result = await response.json();
  if (!result.success) {
    throw new Error(result.message || 'Terjadi kesalahan pada server.');
  }
  return result;
}

export const api = {
  // Auth
  login: (username, password) => callApi('login', { username, password }),

  // Siswa
  getSiswa: (kelas) => callApi('getSiswa', { kelas }),
  addSiswa: (data) => callApi('addSiswa', data),
  updateSiswa: (data) => callApi('updateSiswa', data),
  nonAktifkanSiswa: (id) => callApi('nonAktifkanSiswa', { id }),
  hapusSiswa: (ids) => callApi('hapusSiswa', { ids }),
  pindahKelas: (ids, kelasBaru) => callApi('pindahKelas', { ids, kelasBaru }),
  importSiswa: (siswaList) => callApi('importSiswa', { siswaList }),
  getTemplateUrl: () => callApi('getTemplateUrl'),

  // Kehadiran (skema baru: per "Jam ke-", bukan lagi "Sesi" berbasis teks)
  // getKehadiran mengembalikan SEMUA jam yang sudah tersimpan pada
  // tanggal+kelas itu, lintas kolom/jam sekaligus.
  getKehadiran: (tanggal, kelas) => callApi('getKehadiran', { tanggal, kelas }),
  // payload: { tanggal, kelas, mataPelajaran, kolom: [{ jamKe, records }] }
  saveKehadiran: (data) => callApi('saveKehadiran', data),

  // Jurnal Pembelajaran
  getKehadiranByKelas: (kelas) => callApi('getKehadiranByKelas', { kelas }),
  getJurnal: (kelas) => callApi('getJurnal', { kelas }),
  saveJurnalEntry: (data) => callApi('saveJurnalEntry', data),
  hapusJurnalEntry: (tanggal, kelas) => callApi('hapusJurnalEntry', { tanggal, kelas }),

  // Laporan
  getLaporan: (params) => callApi('getLaporan', params),

  // Backup
  backupSekarang: () => callApi('backupSekarang'),
};
